import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { unitAppDetail } from "@/service/appList";
import { ensureIWorkMirrorUnit } from "@/service/structure.js";
import Back from "@/components/Back.vue";
import AppDetailBindModal from "@/views/MGT/AppDetail/AppDetailModal/app-detail-bind-modal.vue";
import AppDetailTabAzure from "@/views/MGT/AppDetail/AppDetailTabs/AppDetailTab-azure.vue";
import AppDetailTab1 from "@/views/MGT/AppDetail/AppDetailTabs/AppDetailTab1.vue";
import AppDetailTab2 from "@/views/MGT/AppDetail/AppDetailTabs/AppDetailTab2.vue";
import AppDetailTab3 from "@/views/MGT/AppDetail/AppDetailTabs/AppDetailTab3.vue";
import AppDetailTab4 from "@/views/MGT/AppDetail/AppDetailTabs/AppDetailTab4.vue";
import AppDetailTab5 from "@/views/MGT/AppDetail/AppDetailTabs/AppDetailTab5.vue";
import AppDetailTab6 from "@/views/MGT/AppDetail/AppDetailTabs/AppDetailTab6.vue";
import AppDetailTab2Third from "@/views/MGT/AppDetail/AppDetailTabs/AppDetailTab2-third.vue";
import AppDetailTab3Third from "@/views/MGT/AppDetail/AppDetailTabs/AppDetailTab3-third.vue";
import AppDetailTab7 from "@/views/MGT/AppDetail/AppDetailTabs/AppDetailTab7.vue";
import AppDetailTab8 from "@/views/MGT/AppDetail/AppDetailTabs/AppDetailTab8.vue";
export default {
  name: "appDetail",
  components: {
    Back,
    AppDetailBindModal,
    AppDetailTab1,
    AppDetailTabAzure,
    AppDetailTab2,
    AppDetailTab3,
    AppDetailTab4,
    AppDetailTab5,
    AppDetailTab6,
    AppDetailTab2Third,
    AppDetailTab3Third,
    AppDetailTab7,
    AppDetailTab8
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false;
      }
    },
    item: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      scopeList: [],
      detail: {},
      detailLoading: false,
      tabValue: "name1",
      downAddress: {
        downloadUrl: null
      }
    };
  },
  computed: {
    //Azure
    isAzure() {
      return this.detail.appId === "ID_AZURE";
    },
    // 自己钉钉
    isDingDing() {
      return this.detail.appId === "DING_TALK_SYNC";
    },
    // 第三方钉钉
    _isThirdDingDing() {
      return this.detail.appId === "ID_UPSTREAM_DING_TALK";
    },
    // 企业微信
    _isEnterpriseWechat() {
      return this.detail.appId === "ID_UPSTREAM_WECHAT_WORK_PRIVATE";
    },
    // opera
    _isOperaCloud() {
      // return this.detail.appId === "ID_OPERA_CLOUD";
      return false;
    },
    // 需要显示部门管理跟角色管理
    _third() {
      return this._isThirdDingDing || this._isEnterpriseWechat;
    },
    showPoptip() {
      return (this._third || this.isDingDing) && this.tabValue === "name1";
    }
  },
  watch: {
    visible(val) {
      val && this.init();
    }
  },
  methods: {
    async init() {
      this.getAppDetail();
    },
    close() {
      this.detail = {};
      this.scopeList = [];
      this.downAddress.downloadUrl = null;
      this.tabValue = "name1";
      this.$emit("close");
    },
    async getAppDetail() {
      let res = await unitAppDetail(this.item.id);
      if (res.data && res.data.result == 0) {
        res.data.retVal.all = res.data.retVal.all === "T" ? true : false;
        this.detail = res.data.retVal;
        if (this._isOperaCloud) {
          this.iWorkMirrorUnit();
        }
        this.detail.isHalt = this.detail.isHalt || "F";
        // 记录接口返回的下载地址，以便更新的时候进行比较
        this.downAddress.downloadUrl = this.detail.downloadUrl;
        this.setScope(res.data.retVal);
      }
    },
    /*
     * 初始化iwork镜像上游单位
     */
    async iWorkMirrorUnit() {
      this.detailLoading = true;
      let res = await ensureIWorkMirrorUnit(this.item.id);
      if (res.data && res.data.result == 0) {
        this.detailLoading = false;
      }
    },
    setScope(value) {
      let arr = [];
      let orgs = value.orgs;
      let tags = value.tags;
      let users = value.users;
      orgs.map(v => {
        arr.push({
          name: v.name,
          orgId: v.uuid,
          type: "ORG"
        });
      });
      tags.map(v => {
        arr.push({
          name: v.name,
          tagId: v.uuid,
          type: "TAG"
        });
      });
      users.map(v => {
        arr.push({
          name: v.name,
          userId: v.uuid,
          isUserByTree: true,
          type: "USER"
        });
      });
      this.scopeList = arr;
    },
    /*
     * 打开人员弹窗
     */
    onChangeUser() {
      this.$refs["AppDetailBindModal"].open();
    }
  }
};